<template>
  <section id="home" class="half" >
    <div class="big mbig" v-html="home.text"></div>
  </section>
</template>

<script>
export default {
  computed: {
    home() {
      return this.$store.state.site.home;
    }
  }
};
</script>

<style lang="scss" scoped>
#home {
  height: 100vh;
  position:relative;
  @media only screen and (max-width:768px){
    // padding-top:100vh;
    height:auto;
    overflow:hidden;
    margin-bottom:calc(5 * var(--lh));
    // padding-top:calc(4 * var(--lh));
  }
}
</style>
